import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";

var _a, _b, _c;

import { __awaiter, __generator } from "tslib";
import { ENV_IOS, ENV_ANDROID } from '../../const';
import { env } from '../../getNativeInfo';
import { prepareApi, uniCall, Deferred, withStatics } from '../../utils';
/**
 * 支付类型
 */

export var RequestPayType;

(function (RequestPayType) {
  /** 支付宝 APP 支付 */
  RequestPayType["ALIPAY_MOBILE_CLIENT"] = "alipay_mob_client";
  /** 微信 APP 支付 */

  RequestPayType["WEIXIN_APP"] = "weixin_app";
  /** QQ 钱包支付 */

  RequestPayType["QQ_APP"] = "qq_app";
})(RequestPayType || (RequestPayType = {}));
/**
 * 支付返回状态
 */


export var RequestPayResultStatus;

(function (RequestPayResultStatus) {
  /** 支付成功 */
  RequestPayResultStatus["SUCCESS"] = "success";
  /** 支付取消 */

  RequestPayResultStatus["CANCELED"] = "canceled";
  /** 未知错误 */

  RequestPayResultStatus["UNKNOWN"] = "unknown";
})(RequestPayResultStatus || (RequestPayResultStatus = {}));

var apiPrefixMap = (_a = {}, _a[RequestPayType.ALIPAY_MOBILE_CLIENT] = 'bcz_alipay', _a[RequestPayType.WEIXIN_APP] = 'bcz_weixinpay', _a[RequestPayType.QQ_APP] = 'bcz_qqpay', _a);
var errCodeMap = (_b = {},
/**
 * @link https://opendocs.alipay.com/open/204/105302
 */
_b[RequestPayType.ALIPAY_MOBILE_CLIENT] = {
  '9000': RequestPayResultStatus.SUCCESS,
  '6001': RequestPayResultStatus.CANCELED
},
/**
 * @link https://pay.weixin.qq.com/wiki/doc/api/app/app.php?chapter=8_5
 */
_b[RequestPayType.WEIXIN_APP] = {
  '0': RequestPayResultStatus.SUCCESS,
  '-2': RequestPayResultStatus.CANCELED
},
/**
 * @link https://mp.qpay.tenpay.cn/buss/wiki/38/1196
 */
_b[RequestPayType.QQ_APP] = (_c = {
  '0': RequestPayResultStatus.SUCCESS
}, _c[ENV_IOS] = {
  '-11001': RequestPayResultStatus.CANCELED
}, _c[ENV_ANDROID] = {
  '-1': RequestPayResultStatus.CANCELED
}, _c), _b);

var resolveStatus = function resolveStatus(_a) {
  var _b, _c;

  var type = _a.type,
      code = _a.code;
  var target = errCodeMap[type];
  return (_c = (_b = target[env]) === null || _b === void 0 ? void 0 : _b[code]) !== null && _c !== void 0 ? _c : target[code];
};

export default withStatics(requestPay, {
  /** 请求支付类型 */
  payType: RequestPayType,

  /** 支付返回状态 */
  resultStatus: RequestPayResultStatus
});
/**
 * 发起订单支付请求
 */

export function requestPay(opt) {
  return __awaiter(this, void 0, void 0, function () {
    var type, param, dfd, prefix;
    return __generator(this, function (_a) {
      type = opt.type, param = opt.orderInfo;

      if (!~[RequestPayType.ALIPAY_MOBILE_CLIENT, RequestPayType.WEIXIN_APP, RequestPayType.QQ_APP].indexOf(type)) {
        throw new Error("[requestPay] got invalid parameter (type: ".concat(type, ")"));
      }

      dfd = new Deferred();
      prefix = apiPrefixMap[type];
      prepareApi([prefix]);

      window[prefix].onPayResult = function (result) {
        var _a;

        try {
          var status = void 0;
          var code = void 0;

          if (type === RequestPayType.ALIPAY_MOBILE_CLIENT) {
            var matched = result.match(env === ENV_ANDROID ? /resultStatus={(\d+?)}/ : /resultStatus="(\d+?)"/);

            if (!matched) {
              status = RequestPayResultStatus.UNKNOWN;
            } else {
              code = Number(matched[1]);
              status = resolveStatus({
                type: type,
                code: code
              });
            }
          } else {
            var ret = JSON.parse(result);
            code = Number(ret.errCode);
            status = resolveStatus({
              type: type,
              code: code
            });
          }

          dfd.resolve({
            status: status || RequestPayResultStatus.UNKNOWN,
            code: /-?\d+/.test(String(code)) ? code : null
          });
        } catch (err) {
          dfd.reject(new Error(((_a = err) === null || _a === void 0 ? void 0 : _a.message) || '支付失败'));
        }
      };

      uniCall({
        api: 'pay',
        param: param,
        prefix: prefix
      });
      return [2
      /*return*/
      , dfd.promise];
    });
  });
}